const SPACE_REGEX = /\s+/g;

export const despace = (string: string) => (string || '').replace(SPACE_REGEX, ' ').trim();
